import React from 'react';
import { IconProps } from '../IconProps';
const SvgNovaInfo = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" {...props}>
    <g clipPath="url(#NovaInfo_svg__clip0_5081_13992)">
      <g clipPath="url(#NovaInfo_svg__clip1_5081_13992)">
        <path
          d="M8 15.406a7.2 7.2 0 100-14.4 7.2 7.2 0 000 14.4z"
          stroke="#0D0300"
          strokeWidth={1.2}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.146 11.952V8.274a.334.334 0 00-.334-.334H6.809"
          stroke="#0D0300"
          strokeWidth={1.2}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.146 6.132a.836.836 0 100-1.672.836.836 0 000 1.672z"
          fill="#0D0300"
        />
      </g>
    </g>
    <defs>
      <clipPath id="NovaInfo_svg__clip0_5081_13992">
        <path fill="#fff" transform="translate(0 .206)" d="M0 0h16v16H0z" />
      </clipPath>
      <clipPath id="NovaInfo_svg__clip1_5081_13992">
        <path fill="#fff" transform="translate(0 .206)" d="M0 0h16v16H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgNovaInfo;
